import React from 'react'

const StarRating = (props) => {
  return (
   <div className="text-center pr-5 pl-5 ml-5 mr-5">
    <div className="d-flex justify-content-around mb-1">
      {Array.from({ length: props.max }, (_, i) => i + 1).map((num) => (
        <span key={`num-${num}`} className="rating-number">
          {num}
        </span>
      ))}
    </div>
    <div className="d-flex gap-1 align-items-center justify-content-around rating">

      {Array.from({ length: props.max }, (_, i) => i + 1).map((star) => (
        <span
          key={star}
          className={`star ${star <= props.value ? "active" : ""}`}
          onClick={() => !props.disabled && props.onChange && props.onChange(star)}
        >
          ★
        </span>
      ))}
    </div>
  </div>
  )
}

export default StarRating